import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Screenshots from '../components/Screenshots';
import Download from '../components/Download';
import Footer from '../components/Footer';
import Reviews from '../components/Reviews';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaClock, FaCalendarAlt } from 'react-icons/fa';

const Home = () => {
    return (
        <div className="home-page">
            <Hero />

            <Features />

            <Screenshots />

            {/* Additional Features Section */}
            <section className="section bg-light">
                <div className="container" style={{ textAlign: 'center' }}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        <h2 className="section-title">Ek Özellikler</h2>
                        <p className="section-subtitle">
                            Çalışma verimliliğinizi artıracak ek araçlarımızı keşfedin.
                        </p>
                        <div className="hero-buttons" style={{ justifyContent: 'center', marginTop: '2rem', gap: '1rem' }}>
                            <Link to="/pomodoro" className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <FaClock />
                                Online Pomodoro
                            </Link>
                            <Link to="/countdown" className="btn btn-secondary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <FaCalendarAlt />
                                Sınava Kalan Süre
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </section>

            <Reviews />
            <Download />
            <Footer />
        </div>
    );
};

export default Home;
